module.exports = __webpack_public_path__ + "static/media/Rashi.c0beb218.jpg";